<mat-card class="cardWithShadow">
    <mat-card-content>
        <mat-card-title class="header">
            Plantilla - Configuración
        </mat-card-title> <br>
        <div class="main-container">
            <form class="form_register_minutes" [formGroup]="form" (ngSubmit)="submit()">
              <section class="container-form">

                <mat-form-field class="example-form-field full-width">
                  <mat-label>Nombre</mat-label>
                  <input matInput formControlName="name" />
                </mat-form-field>
          
                <mat-form-field class="example-form-field full-width">
                  <mat-label>Descripción</mat-label>
                  <input matInput type="text" formControlName="description" />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Tamaño</mat-label>
                  <select matNativeControl required formControlName="size">
                    <option value=0>A4</option>
                    <option value=1>A3</option>
                    <option value=2>A2</option>
                    <option value=3>A1</option>
                    <option value=4>Carta</option>
                    <option value=5>Oficio</option>
                  </select>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Orientación</mat-label>
                  <select matNativeControl required formControlName="orientation">
                    <option value=1>Vertical</option>
                    <option value=0>Horizontal</option>
                  </select>
                </mat-form-field>

              </section>
              <section class="button_class">
                <button
                  [disabled]="!form.valid"
                  mat-stroked-button
                  color="primary"
                  type="submit"
                  class="w-50"
                >
                  Guardar
                </button>
              </section>
            </form>
          </div>          
    </mat-card-content>
</mat-card>